var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"drag",rawName:"v-drag"},{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"go-index",attrs:{"src":require("../../images/index.png")},on:{"click":_vm.goIndex}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d80bf65","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/group/components/goIndex/index.vue
// module id = null
// module chunks = 